import React from 'react';
import { Form } from 'react-bootstrap';

const SearchBar = ({ searchQuery, onSearchChange }) => {
  return (
    <Form.Group className="mb-2">
      <Form.Control
        type="text"
        placeholder="Search Restaurant..."
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        size="sm"
      />
    </Form.Group>
  );
};

export default SearchBar;
